module.exports = __webpack_public_path__ + "img/patient-info.c7bfdbff.svg";